// Ported verbatim from admin.gamedevbuddy.com/packages/frontend/src/features/gitlab/lib/constants.ts (Plan 13-03).
// Existing label schema on git.cvcdev.io is the source of truth — do NOT modify
// columns or swim lanes here without coordinating with Craig.
//
// Hex values below are DATA tokens (kanban column accent colors / project
// chips), not styling decisions — they're passed to inline `style={{ ... }}`
// props on the kanban cells. The CONTEXT.md decision lock preserves them
// verbatim. Component-level chrome / typography uses ue.* Tailwind tokens.

import type { ColumnDef, SwimLaneDef } from './types'

export const COLUMNS: ColumnDef[] = [
  { id: 'triage', label: 'Triage', statusLabel: 'status::triage', color: '#f87171' },
  { id: 'backlog', label: 'Backlog', statusLabel: 'status::backlog', color: '#94a3b8' },
  { id: 'todo', label: 'To Do', statusLabel: 'status::todo', color: '#cbd5e1' },
  { id: 'in-progress', label: 'In Progress', statusLabel: 'status::in-progress', color: '#60a5fa' },
  { id: 'review', label: 'Review', statusLabel: 'status::review', color: '#a78bfa' },
  { id: 'beta', label: 'Beta', statusLabel: 'status::beta', color: '#fbbf24' },
  { id: 'production', label: 'Production', statusLabel: 'status::production', color: '#34d399' },
  { id: 'wontfix', label: "Won't Fix", statusLabel: 'status::wontfix', color: '#64748b' },
]

export const SWIM_LANES: SwimLaneDef[] = [
  { type: 'bug', label: 'Bugs', typeLabel: 'type::bug', color: '#f87171' },
  { type: 'feature-request', label: 'Features', typeLabel: 'type::feature-request', color: '#60a5fa' },
  { type: 'user-story', label: 'User Stories', typeLabel: 'type::user-story', color: '#34d399' },
  { type: 'uncategorised', label: 'Uncategorised', typeLabel: null, color: '#94a3b8' },
]

export const PROJECT_COLORS: Record<number, string> = {
  2: '#a78bfa', 6: '#fb923c', 3: '#60a5fa', 28: '#34d399', 29: '#f472b6', 30: '#fbbf24', 34: '#38bdf8',
}

export const PROJECT_NAMES: Record<number, string> = {
  2: 'Hub', 6: 'Plugin', 3: 'Website', 28: 'CharacterCreator', 29: 'Pheme', 30: 'Media', 34: 'App', 4: 'Partners', 5: 'Obsidian',
}

export function getColumnForIssue(labels: string[]): ColumnDef {
  const statusLabel = labels.find((l) => l.startsWith('status::'))
  if (!statusLabel) return COLUMNS[1]
  return COLUMNS.find((c) => c.statusLabel === statusLabel) || COLUMNS[1]
}

export function getSwimLaneForIssue(labels: string[]): SwimLaneDef {
  const typeLabel = labels.find((l) => l.startsWith('type::'))
  if (!typeLabel) return SWIM_LANES[3]
  return SWIM_LANES.find((s) => s.typeLabel === typeLabel) || SWIM_LANES[3]
}
